
import axios from 'axios';

const sendPlainMessage = async (token, contactId, text) => {

    var data = {
      "token": token,
      "contactId": contactId,
      "message": text
    };
    
    const headers = { 
        'Content-Type': 'application/json'
    };

    // console.log(data);
    try {
        let sendMessageResult = await axios.post(process.env.REACT_APP_BACKEND_HOST+'/api/v1/message/send-plain-message', data, { headers })
        // console.log('sendMessageResult', sendMessageResult)
        if(sendMessageResult.data.status !== 200)
            throw new Error(sendMessageResult.data.message); 
    }catch(err) {
        console.log('sendPlainMessage: error received from Axios',err.message);
        throw new Error(err.message); 
    }
};

export default sendPlainMessage